<script lang="ts">
    import type { CriteriaType } from '../store/types';
    import serviceStore from '../store/service';
    import { isDefinedNotNullNotEmpty } from '../helpers/common';
    import { getUrlParam } from '../helpers/url';
    import lang from '../lang/language';
    import { onMount } from 'svelte';
    import Datepicker from './Datepicker.svelte';
    import { name, price, type, date } from '../store/search';

    export let search;

    function getSubtitle() {
        let subtitle = '';
        switch ($type) {
            case '0':
                subtitle = lang.search_accommodation;
                break;
            case '1':
                subtitle = lang.search_activity;
                break;
            case '2':
                subtitle = lang.search_restaurant;
                break;
            case '3':
                subtitle = lang.search_product;
                break;
            default:
                subtitle = lang.search_everything;
                break;
        }
        return subtitle;
    }
</script>

<div class="search-wrapper">
    <h1
        class="title"
        style="margin-bottom: 20px; width: 100%;text-align: center"
    >
        {lang.search_title}
    </h1>
    <div class="form-wrapper">
        <div class="row">
            <div class="input-wrapper icon calendar">
                <Datepicker placeholder={lang.date} {$date} />
            </div>
        </div>
        <div
            class="row"
            style={`display: ${getUrlParam('type') ? 'none' : 'block'}`}
        >
            <div class="input-wrapper icon category">
                <select
                    class="input-field"
                    type="text"
                    placeholder="Choose Category"
                    bind:value={$type}
                >
                    <option value="">{lang.search_all_categories}</option>
                    <option value="0">{lang.accommodation}</option>
                    <option value="1">{lang.activity}</option>
                    <option value="2">{lang.restaurant}</option>
                    <option value="3">{lang.produce}</option>
                </select>
            </div>
        </div>
        <div class="row">
            <div class="input-wrapper icon price">
                <select
                    class="input-field"
                    type="text"
                    placeholder="Choose price"
                    bind:value={$price}
                >
                    <option value="">{lang.search_price_range}</option>
                    <option value="1-9999">&lt; ¥9.999</option>
                    <option value="10000-14999">¥10.000 - ¥14.999</option>
                    <option value="15000-19999">¥15.000 - ¥19.999</option>
                    <option value="20000-">¥20.000 +</option>
                </select>
            </div>
        </div>
        <div class="row">
            {#if parseInt($type) != 3}
                <div class="input-wrapper icon keyword">
                    <input
                        bind:value={$name}
                        class="input-field"
                        type="text"
                        placeholder={lang.search_keyword}
                    />
                </div>
            {:else}
                <div class="input-wrapper icon category">
                    <select
                        class="input-field"
                        type="text"
                        placeholder="Choose Keyword"
                        bind:value={$name}
                    >
                        <option value="">{lang.search_all_categories}</option>
                        <option value={lang.dairy}>{lang.dairy}</option>
                        <option value={lang.sweet}>{lang.sweet}</option>
                        <option value={lang.wine}>{lang.wine}</option>
                    </select>
                </div>
            {/if}
        </div>
        <div class="row text-center">
            <button
                class="search-button"
                style="width: 100%;height: 100%"
                on:click={search}
            >
                {lang.search_button}
            </button>
        </div>
    </div>
</div>

<style>
    .subtitle,
    .subsubtitle {
        text-align: left;
    }

    .subtitle {
        color: white;
        font-weight: bold;
        color: white;
        padding: 5px 10px;
        letter-spacing: 2px;
    }

    .subsubtitle {
        padding: 15px 5px;
    }

    .search-wrapper {
        text-align: center;
    }

    .form-wrapper {
        display: flex;
        justify-content: space-evenly;
        gap: 5px;
    }

    .row {
        flex: 1;
    }

    :global(.input-wrapper) {
        border: 1px solid grey;
        height: 51px;
        width: 100%;
    }

    :global(.input-field) {
        height: 100%;
        line-height: 51px;
        padding: 0 20px;
        outline: none;
        font-size: 15px;
        color: #808080;
        max-width: 100%;
        width: 100%;
        box-sizing: border-box;
        display: block;
        background-color: #fff;
        border: none;
        height: 100%;
        /*box-shadow: 0 1px 3px 0px rgb(0 0 0 / 6%);*/
        font-weight: 500;
        opacity: 1;
        border-radius: 3px;
    }

    .icon {
        background-repeat: no-repeat;
        background-position: 10px center;
        background-size: 20px;
        padding-left: 40px;
    }

    .category {
        background-image: url('../icons/category.png');
    }

    .price {
        background-image: url('../icons/price.png');
    }

    .keyword {
        background-image: url('../icons/keyword.png');
    }

    .calendar {
        background-image: url('../icons/calendar.png');
    }

    @media screen and (max-width: 900px) {
        .form-wrapper {
            flex-direction: column;
            gap: 2px;
        }
    }
</style>
